import { useState, useCallback, type ReactNode } from 'react';
import { ReportStateContext, type IPowerBISlicerConfig } from './ReportStateContext';

export function ReportStateProvider({ children }: { children: ReactNode }) {
    const appVersion = import.meta.env.VITE_APP_VERSION || 'dev';
    const STORAGE_KEY = `v${appVersion}_adap_report_slicers_${window.location.hostname}`;

    const [reportStates, setReportStates] = useState<Record<string, IPowerBISlicerConfig[]>>(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            return stored ? JSON.parse(stored) : {};
        } catch (e) {
            console.error("Failed to load report states from local storage", e);
            return {};
        }
    });

    const getReportSlicers = useCallback((reportId: string) => {
        return reportStates[reportId];
    }, [reportStates]);

    const saveReportSlicers = useCallback((reportId: string, slicers: IPowerBISlicerConfig[]) => {
        setReportStates(prev => {
            const newState = {
                ...prev,
                [reportId]: slicers
            };
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
            } catch (e) {
                console.error("Failed to save report states to local storage", e);
            }
            return newState;
        });
    }, [STORAGE_KEY]);

    return (
        <ReportStateContext.Provider value={{ getReportSlicers, saveReportSlicers }}>
            {children}
        </ReportStateContext.Provider>
    );
}
